import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export function useFormatUnixTimeToNow(timestamp?: number) {
  if (!timestamp) {
    return '-';
  }

  return dayjs.unix(timestamp).fromNow(true);
}
